<template>
  <div class="chart-container">
    <chart :options="options" />
  </div>
  </template>
  
  <script>
  import { Chart } from 'highcharts-vue'
  import Highcharts from 'highcharts'
  import exportingInit from 'highcharts/modules/variable-pie'
  exportingInit(Highcharts)
  
  export default {
    components: {
      Chart 
    },
    props: {
      chartData: {
        type: Object,
        default: () => {}
      },
      size: {
        type: Number,
        default: 240
      },
      title: {
        type: String,
        default: null
      }
    },
    data() {
      return {
        options: {
          colors: [ '#00df9a', '#164194', '#ffbe3c', '#002c65'],
          chart: {
          plotBackgroundColor: 'white',
          plotBorderWidth: 0,
          plotShadow: false
      },
      title: {
          text: '',
          align: 'center',
          verticalAlign: 'middle',
          y: 60,
          style: {
            display: 'none'
          }
      },
      tooltip: {
          headerFormat: '<span style="font-size:11px">{point.name}</span><br>',
          pointFormat: this.pointType == 1 ? '<span style="color:{point.color}">{point.name}</span>: {point.y} TL<br/>% {point.percentage:.2f}' : '<span style="color:{point.color}">Oran:</span> <b>{point.name:.2f}%</b><br/>',
          style: {
            fontFamily: 'BwGlennSans-Regular',
            fontSize: '14px'
          }
        },
      accessibility: {
          point: {
              valueSuffix: '%'
          }
      },
      
      plotOptions: {
          pie: {
              dataLabels: {
                  enabled: true,
                  distance: -50,
                  style: {
                      fontWeight: 'bold',
                      color: 'white'
                  },
                  format: '% {point.percentage:.0f}',
              },
              startAngle: -90,
              endAngle: 90,
              center: ['50%', '75%'],
              size: '110%'
          }
      },
      credits: {
          enabled: false
        },
      series: [{
          type: 'pie',
          innerSize: '50%',
          data: this.chartData
      }],
      
        }
      }
      
    },
    watch:{
    chartData(newData){
      this.options.series[0].data = newData;
    }
     }
  }
 
  </script>
  <style scoped>
.chart-container{
  width: 100%;
  height: 70%;
}
  </style>
